import React from 'react';
import styled, { css, keyframes } from 'styled-components';

import { elevation } from "../Styles/Utils";

/* istanbul ignore file */

export const Sides = {
  BOTTOM: 'BOTTOM',
  TOP: 'TOP' };


export const SnapPositions = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT' };


const PositionPairs = {
  topLeft: `${Sides.TOP}-${SnapPositions.LEFT}`,
  topRight: `${Sides.TOP}-${SnapPositions.RIGHT}`,
  bottomLeft: `${Sides.BOTTOM}-${SnapPositions.LEFT}`,
  bottomRight: `${Sides.BOTTOM}-${SnapPositions.RIGHT}` };


export const TriangleSVG = ({ className, fill, style }) => /*#__PURE__*/
React.createElement("svg", {
  style: style,
  className: className,
  width: "24",
  height: "12",
  viewBox: "0 0 24 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement("path", { d: "M12 0L0 12H24L12 0Z", fill: fill }), /*#__PURE__*/
React.createElement("path", { d: "M12 0L0 12H24L12 0Z", fill: fill, fillOpacity: "0.75" }));



export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Container", componentId: "sc-2ts956-0" })(["position:relative;box-sizing:border-box;display:inline-block;"]);





export const ChildrenContainer = /*#__PURE__*/styled(Container).withConfig({ displayName: "styled__ChildrenContainer", componentId: "sc-2ts956-1" })(["display:flex;&:hover{cursor:pointer;}"]);







export const CommonTriangle = /*#__PURE__*/styled(TriangleSVG).withConfig({ displayName: "styled__CommonTriangle", componentId: "sc-2ts956-2" })(["position:absolute;z-index:", ";", ""],

(props) => props.zIndex || 12,
(props) =>
props.side === Sides.TOP &&
css(["transform:rotate(180deg);"]));




export const Triangles = {
  [Sides.BOTTOM]: styled(CommonTriangle).withConfig({ displayName: "styled__BOTTOM", componentId: "sc-2ts956-3" })(["bottom:100%;"]),


  [Sides.TOP]: styled(CommonTriangle).withConfig({ displayName: "styled__TOP", componentId: "sc-2ts956-4" })(["top:100%;"]) };




export const appear = /*#__PURE__*/keyframes(["0%{opacity:0;transform:translateY(16px);}100%{opacity:1;transform:translateY(0px);}"]);










export const hover = /*#__PURE__*/keyframes(["0%{transform:translateY(0px);}50%{transform:translateY(4px);}100%{transform:translateY(0px);}"]);











export const AnimationContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__AnimationContainer", componentId: "sc-2ts956-5" })(["animation:", " 3s infinite;"],
hover);


export const TextContainer = /*#__PURE__*/styled(Container).withConfig({ displayName: "styled__TextContainer", componentId: "sc-2ts956-6" })(["position:absolute;animation:", " 0.5s ease-out;", ""],






appear,

(props) => {
  switch (`${props.side}-${props.snapPosition}`) {
    case PositionPairs.topLeft:{
        return `
            bottom: ${props.verticalOffset}px;
            left: ${props.pointerOffset || 0}px;
          `;
      }

    case PositionPairs.topRight:{
        return `
            bottom: ${props.verticalOffset}px;
            right: ${props.pointerOffset || 0}px;
          `;
      }

    case PositionPairs.bottomLeft:{
        return `
            top: ${props.verticalOffset}px;
            left: ${props.pointerOffset || 0}px;
          `;
      }

    case PositionPairs.bottomRight:{
        return `
            top: ${props.verticalOffset}px;
            right: ${props.pointerOffset || 0}px;
          `;
      }

    default:
      return '';}

});


export const Text = /*#__PURE__*/styled.p.withConfig({ displayName: "styled__Text", componentId: "sc-2ts956-7" })(["margin:0;color:", ";", ";"],

({ theme }) => theme.colors.Background,
(props) => css(props.theme.typography.Paragraph));


export const Wrap = /*#__PURE__*/styled(Container).withConfig({ displayName: "styled__Wrap", componentId: "sc-2ts956-8" })(["position:relative;text-transform:none;user-select:none;pointer-events:none;min-width:", "px;max-width:384px;text-align:center;white-space:", ";padding:8px;border-radius:8px;background:", ";color:", ";z-index:", ";", ""],








(props) => props.width,


(props) => props.textWrap ? 'normal' : 'nowrap',


(props) => props.theme.colors.secondary,
({ theme }) => theme.colors.Background,
(props) => props.zIndex || 12,

elevation(3, false));